var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89844 5.99961C2.89844 5.36309 3.15129 4.75264 3.60138 4.30255C4.05147 3.85247 4.66192 3.59961 5.29844 3.59961H13.6984C14.335 3.59961 14.9454 3.85247 15.3955 4.30255C15.8456 4.75264 16.0984 5.36309 16.0984 5.99961V10.7996C16.0984 11.4361 15.8456 12.0466 15.3955 12.4967C14.9454 12.9468 14.335 13.1996 13.6984 13.1996H11.2984L7.69844 16.7996V13.1996H5.29844C4.66192 13.1996 4.05147 12.9468 3.60138 12.4967C3.15129 12.0466 2.89844 11.4361 2.89844 10.7996V5.99961Z",
    fill: "#4A3DFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4984 8.39961V10.7996C18.4984 12.0726 17.9927 13.2935 17.0926 14.1937C16.1924 15.0939 14.9715 15.5996 13.6984 15.5996H12.292L10.1728 17.72C10.5088 17.8988 10.8916 17.9996 11.2984 17.9996H13.6984L17.2984 21.5996V17.9996H19.6984C20.335 17.9996 20.9454 17.7468 21.3955 17.2967C21.8456 16.8466 22.0984 16.2361 22.0984 15.5996V10.7996C22.0984 10.1631 21.8456 9.55264 21.3955 9.10255C20.9454 8.65247 20.335 8.39961 19.6984 8.39961H18.4984Z",
    fill: "#4A3DFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIconDark);
export default __webpack_public_path__ + "static/media/messageIconDark.75503ffa09e5a4e5c892dd86c906945c.svg";
export { ForwardRef as ReactComponent };